import useRequest from "~/composables/use-request";
import Event from "./event.model";

const EventStatsAPI = {
  getEventScoreStatsById(id: string): Promise<IEventStats> {
    const { request } = useRequest();
    const runtimeConfig = useRuntimeConfig().public;
    const isModernUX = runtimeConfig.APP_CUSTOMER?.enable_modern_ux;

    const query: Record<string, boolean | string> = {
      id,
      score: true,
      overview: true,
    };

    if (isModernUX) {
      query.rosterOverview = true;
    }

    return request
      .get<IContentResponse<IResponseEventVidswapStats>>("/api/event/stats", { query })
      .then((res) => {
        const scores = Event.formatScoreStats(res.content?.vidswap?.["game-scores"]);
        const overview = Event.formatGameStats(res.content?.vidswap?.["game-overview"]);
        const rosterOverview = Event.formatRosterOverview(res.content?.vidswap?.["game-roster-overview"]);

        return { scores, overview, rosterOverview };
      });
  },
};

export default EventStatsAPI;
